module.exports = __webpack_public_path__ + "static/img/edge.11da564.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/edge.png
// module id = Iwu1
// module chunks = 0